import { useRef, useState, useEffect } from "react";
import { Button, Col, Row } from "antd";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

import { LightBlueContainer, WhiteContainer } from "../../styled/Container.styled";
import { CloseButton } from "../../styled/Button.styled";
import NotificationItem, { NotificationItemHandle } from "./NotificationItem";

const inputFileLabelStyle: React.CSSProperties = {
  width: "117%",
  padding: "2%",
  background: "#3e4685",
  borderRadius: "5px",
  border: "2px solid #3e4685",
  color: "white",
  cursor: "pointer",
  display: "inline-block",
  marginTop: "1rem",
  textAlign: "center",
  fontSize: "20px",
  transition: "background-color 0.3s ease",
  height: "57%",
};

const NotificationContainer = styled.div`
  height: auto;
  overflow: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
`;

function Notification() {
  const navigate = useNavigate();
  const notificationRef = useRef<NotificationItemHandle>(null);
  const [hasNotifications, setHasNotifications] = useState(false);

  const handleClose = () => {
    navigate("/dashboard");
  };

  const handleMarkAsRead = () => {
    notificationRef.current?.markAllAsRead();
    setHasNotifications(false); // Hide button after marking all as read
  };

  useEffect(() => {
    // Delay until after component mounts
    const checkNotifications = () => {
      if (notificationRef.current?.hasUnread()) {
        setHasNotifications(true);
      } else {
        setHasNotifications(false);
      }
    };

    // Run once after mount
    setTimeout(checkNotifications, 100);
  }, []);

  return (
    <LightBlueContainer>
      <WhiteContainer>
        <NotificationContainer>
          <Row justify="end" gutter={[45, 10]}>
            {hasNotifications && (
              <Col>
                <Button type="primary" onClick={handleMarkAsRead} style={inputFileLabelStyle}>
                  Mark as Read
                </Button>
              </Col>
            )}
            <Col className="button-bottom-margin">
              <CloseButton onClick={handleClose} />
            </Col>
            <Col span={24}>
              <NotificationItem ref={notificationRef} />
            </Col>
          </Row>
        </NotificationContainer>
      </WhiteContainer>
    </LightBlueContainer>
  );
}

export default Notification;
